export default theme => ({
  wrapper: {
    display: 'flex',
    margin: theme.spacing(0)
  },
  wrapperChild: {
    flex: 1,
  },
  stopDetail: {
    margin: theme.spacing(1)
  },
});

